<div class="common-container">
  <p class="common-info">Manage your workspace status.</p>
</div>
<div class="document-content">
  @if (currentWorkspace) {
    <div class="metric-wrapper">
      <div class="metric-icon rounded-icon" [class]="currentWorkspace | workspaceStatusClass"></div>
      <div class="metric-details">
        <div class="metric-label">Workspace status</div>
        <div class="metric-value">
          {{ currentWorkspace | workspaceStatus }}
        </div>
      </div>
    </div>

    <div class="actions" *appRequiredRoles="['admin', 'editor', 'reviewer']">
      <div class="status-actions">
        <button
          *appRequiredRoles="[
            { role: 'admin', status: ['ACTIVE', 'IN_REVIEW', 'APPROVED', 'FINISHED'] },
            { role: 'reviewer', status: ['ACTIVE', 'IN_REVIEW', 'APPROVED', 'FINISHED'] }
          ]"
          [disabled]="isLoading || currentWorkspace.is_deleted"
          [class]="'DRAFTING' | workspaceStatusClass"
          mat-flat-button
          (click)="moveToDrafting()"
          [color]="'primary'">
          Move to Drafting
        </button>

        <button
          *appRequiredRoles="[{ role: 'admin', status: 'DRAFTING' }]"
          [disabled]="isLoading || currentWorkspace.is_deleted"
          [class]="'IN_REVIEW' | workspaceStatusClass"
          mat-flat-button
          (click)="moveToReview()"
          [color]="'primary'">
          Move to Review
        </button>
        <button
          *appRequiredRoles="[
            { role: 'admin', status: 'IN_REVIEW' },
            { role: 'reviewer', status: 'IN_REVIEW' }
          ]"
          [disabled]="isLoading || currentWorkspace.is_deleted"
          [class]="'APPROVED' | workspaceStatusClass"
          mat-flat-button
          (click)="moveToApprove()"
          [color]="'primary'">
          Move to Approved
        </button>
        <button
          *appRequiredRoles="[{ role: 'admin', status: 'APPROVED' }]"
          [disabled]="isLoading || currentWorkspace.is_deleted"
          [class]="'FINISHED' | workspaceStatusClass"
          mat-flat-button
          (click)="moveToFinish()"
          [color]="'primary'">
          Move to Finished
        </button>
      </div>
      <div class="extra-actions" *appRequiredRoles="['admin']">
        <button
          mat-flat-button
          [color]="currentWorkspace.is_archived ? 'primary' : 'accent'"
          (click)="changeStatus(!currentWorkspace.is_archived)"
          [disabled]="isLoading || currentWorkspace.is_deleted">
          {{ currentWorkspace.is_archived ? 'Unarchive' : 'Archive' }}
        </button>

        <button
          mat-flat-button
          color="warn"
          (click)="handleDelete()"
          [disabled]="isLoading || currentWorkspace.is_deleted">
          Delete
        </button>
      </div>
    </div>
  }
</div>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
